import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import { Constants } from 'src/app/constants';
import { AddContingencyDialogComponent } from 'src/app/core/dialogs/add-contingency-dialog/add-contingency-dialog.component';
import { AddQueueDialogComponent } from 'src/app/core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { DeleteDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-dialog.component';
import { GridDropdownEditorComponent } from 'src/app/core/grid/grid-dropdown-edit.component';
import { GridRefreshComponent } from 'src/app/core/grid/grid-refresh.component';
import { GridTextEditorComponent } from 'src/app/core/grid/grid-text-edit.component';
import { HeaderCheckboxComponent } from 'src/app/core/grid/header-checkbox.component';
import { RowCheckboxComponent } from 'src/app/core/grid/row-checkbox.component';
import { ExcelService } from 'src/app/service/excel.service';
import { GridDataService } from 'src/app/service/grid-data.service';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { ContingencyPCSService } from 'src/app/service/pcs/contingency-pcs.service';


@Component({
  selector: 'app-contingency-pcs',
  templateUrl: './contingency-pcs.component.html',
  styleUrls: ['./contingency-pcs.component.scss'],
  standalone: false
})
export class ContingencyPCSComponent implements OnInit {
  @ViewChild('ContigencyPCSGrid') ContigencyPCSGrid;
  gridApi: any;
  icons;
  columnDefs = [];
  displayRowData = [];
  context: any;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;
  selected_period_value
  selected_period_id;

  PCSWriteAccess = true;
  recentcheckedbox;
  rowChecked
  gridOptions
  headerChecked
  updatedRowIds = [];
  oldDataArray: any = [];

  plantList = []
  domicileRouteMasterList = []
  contDoubleMasterList = []
  dsReqNeedList = []
  lmDiagramSketch = []
  dsWithoutReqSuppliers = []
  dockList = []
  plantDockList = [];
  defaultColDef;
  successMessage
  errorMessage
  isAccessible = true;
  const_header = 'DS Request Needed Y/N'
  const_header_vol = 'Volume (M3)'
  const_headr_evl = 'Evaluation Comment'
  const_headr_route = 'Route'
  const_headr_date = 'Doubleship Date'
  const_headr_prdn = 'Contingency Production Date'
  const_headr_sppl = 'NA Supplier Code'

  constructor(private readonly router: Router, public dialog: MatDialog, private readonly ngxUiLoaderService: NgxUiLoaderService,
    private readonly excelService: ExcelService, private readonly contingencyPCSService: ContingencyPCSService,
    private readonly constants: Constants, private readonly gridDataService: GridDataService, private readonly groupIStateService: GroupIStateService) {
    this.context = {
      componentParent: this
    };

    this.defaultColDef = {
      suppressMovable: true, wrapText: true, floatingFilter: true,
      filterParams: {
        newRowsAction: 'keep'
      }, suppressHeaderFilterButton: true, suppressCellSelection: true
    }

  }

  ngOnInit(): void {
    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.gridOptions = this.gridDataService.getGridOptions();
    this.getColDefs();
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    // this.checkRoles();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }

  async checkRoles() {
    await this.groupIStateService.getRoles();
    const roles = this.groupIStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) ||
    //     userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin) || 
    //     userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser))
    // {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // }
  }

  componentEventHandler(event) {

    if (event.eventType == "NOTIFICATION_ERROR") {  // NOSONAR
      this.errorMessage = event.eventMessage;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
    } else if (event.eventType == "CHANGE_PERIOD") {  // NOSONAR
      this.selected_period_id = event.periodId
      this.selected_period_value = event.periodValue
      this.getBaseDropDownDataAPI()
    }
  }
  userCheckChanged(checked, rowIndex) {

    this.recentcheckedbox = rowIndex;
    const rowNode = this.gridApi.getDisplayedRowAtIndex(rowIndex);
    this.rowChecked = checked;
    if (checked == true) {  // NOSONAR
      rowNode.setSelected(true);
      rowNode.data.checkedEditMode = true;
      rowNode.data.rowCheckBox = true;
      rowNode.setData(rowNode.data);
      this.updatedRowIds.push(rowNode.data.contingencypcsID)
    }

    else {
      const tempObj = this.oldDataArray.find(x => x.contingencypcsID == rowNode.data.contingencypcsID)  // NOSONAR
      this.updatedRowIds.splice(this.updatedRowIds.indexOf(rowNode.data.contingencypcsID), 1)
      rowNode.setSelected(false);
      rowNode.data.checkedEditMode = false;
      rowNode.data.rowCheckBox = false;
      rowNode.setData(tempObj);
    }
    this.updatedRowIds = [... new Set(this.updatedRowIds)]
    this.toogleHeaderCheckBox(checked);
  }

  toogleHeaderCheckBox(checked) {
    if (checked) {
      const rowCount = this.displayRowData.length;
      const selectedRowCount = this.displayRowData.filter(x => x.rowCheckBox == true).length;  // NOSONAR
      if (rowCount == selectedRowCount) {  // NOSONAR
        this.ContigencyPCSGrid.gridOptions.columnDefs[0].headerComponentFramework.checked = checked;
        this.gridApi.refreshHeader();
      }
    } else {
      this.columnDefs[0].headerComponentFramework.checked = checked;
      this.gridApi.refreshHeader();
    }
  }
  headerCheckChanged(checked) {
    const headerChecked = checked;
    this.headerChecked = headerChecked;
    this.gridApi?.forEachNode((rowNode, _index) => {
      const contingencypcsid = rowNode.data.contingencypcsID;
      if (headerChecked) {
        this.updatedRowIds.push(contingencypcsid)
        rowNode.data.rowCheckBox = true;
        rowNode.data.checkedEditMode = true;
        rowNode.setData(rowNode.data);
      } else {
        const tempObj = this.oldDataArray.find(x => x.contingencypcsID == rowNode.data.contingencypcsID)  // NOSONAR
        this.updatedRowIds.splice(this.updatedRowIds.indexOf(rowNode.data.contingencypcsID), 1)
        rowNode.data.rowCheckBox = false;
        rowNode.data.checkedEditMode = false;
        rowNode.setData(tempObj);
      }
    });

    this.updatedRowIds = [... new Set(this.updatedRowIds)]
  }

  async getBaseDropDownDataAPI() {
    try {
      if (this.selected_period_id) {
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        this.domicileRouteMasterList = []
        this.plantList = []
        this.dockList = []
        this.contDoubleMasterList = []
        this.dsReqNeedList = []

        await this.contingencyPCSService.getContingencyMasterPCS(this.selected_period_id).then(x => {
          if (x && x.length > 0) {
            this.contDoubleMasterList = x;
          }
        })
        await this.contingencyPCSService.getContingencyLLT(this.selected_period_id).then((x) => {
          if (x && x.length > 0) {
            this.domicileRouteMasterList = x;
          }
        })

        await this.contingencyPCSService.getPlantsDockDropDown(this.selected_period_id).then(x => {

          if (x && x.length > 0) {
            this.plantDockList = x
            x.forEach((obj, index) => {
              if (obj.plant != null) { this.plantList.push({ id: index + 1, value: obj.plant }) } // NOSONAR
              if (obj.dock != null) { this.dockList.push({ id: index + 1, value: obj.dock }) } // NOSONAR
            })
            this.plantList.sort((a, b) => (a.value > b.value ? 1 : -1))
            this.dockList.sort((a, b) => (a.value > b.value ? 1 : -1))
          }
        })

        this.lmDiagramSketch = [
          { id: "INCOMPLETE", value: 'INCOMPLETE' },
          { id: "COMPLETE", value: 'COMPLETE' },
        ]
        this.dsReqNeedList = [
          { id: "Y", value: 'Yes' },
          { id: "N", value: 'No' },
        ]
        this.dsWithoutReqSuppliers = [
          { id: "Y", value: 'Yes' },
          { id: "N", value: 'No' },
        ]
        const BaseDropDownList = {
          dock: this.dockList,
          dsReqNeed: this.dsReqNeedList,
          dsWithoutReqSuppliers: this.dsWithoutReqSuppliers,
          lmDiagramSketch: this.lmDiagramSketch,
          plantDockList: this.plantDockList
        }
        localStorage.setItem("PCS-base-dropdown-items", JSON.stringify(BaseDropDownList))
      }
    }
    catch (err) {
      // Handle error gracefully here (optional: show a message to the user)
    } finally {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
    }
    this.refreshData();
  }


  getColDefs() {

    this.columnDefs = [
      {
        headerName: "", field: "rowCheckBox", pinned: "left", width: 30, minWidth: 30,
        headerComponentFramework: HeaderCheckboxComponent,
        floatingFilterComponentFramework: GridRefreshComponent,
        floatingFilterComponentParams: { suppressFilterButton: true },
        cellClass: 'ui-grid-cell-contents-auto',

        cellRenderer: RowCheckboxComponent,
        cellRendererParams: { page: 'contingencyPCS' },
        floatingFilter: true,
        lockVisible: true,
      },
      {
        headerName: this.const_headr_prdn, field: "contprodDate", width: 140,
        minWidth: 140, floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', sortable: true, unSortIcon: true, comparator: this.dateComparator
      },
      {
        headerName: this.const_headr_date, field: "doubleshipDate", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', minWidth: 140, width: 120, sortable: true, unSortIcon: true, comparator: this.dateComparator
      },
      {
        headerName: "Plant", field: "plant", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', minWidth: 110, width: 110, sortable: true, unSortIcon: true,
        cellRenderer: GridDropdownEditorComponent,
        cellRendererParams: { column: 'plantCOL', isWrireAccess: this.PCSWriteAccess },
      },
      {
        headerName: "Domicile", field: "domicile", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, sortable: true, unSortIcon: true,
        filter: 'agTextColumnFilter', minWidth: 110, width: 110,
      }, {
        headerName: this.const_headr_route, field: "route", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, sortable: true, unSortIcon: true,
        filter: 'agTextColumnFilter', minWidth: 110, width: 110,
      }, {
        headerName: this.const_headr_sppl, field: "nasuppliercode", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true, sortable: true, unSortIcon: true,
        filter: 'agTextColumnFilter', minWidth: 140, width: 140,
        cellRenderer: GridTextEditorComponent,
        cellRendererParams: { column: 'nasuppliercodeCOL', placeholder: this.const_headr_sppl, isWriteAccess: this.PCSWriteAccess },
      }, {
        headerName: "Dock", field: "dock", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        sortable: true, unSortIcon: true, filter: 'agTextColumnFilter', minWidth: 110, width: 110,
        cellRenderer: GridDropdownEditorComponent,
        cellRendererParams: { column: 'dockCOL', isWrireAccess: this.PCSWriteAccess },
      }, {
        headerName: this.const_headr_evl, field: "evaluation_comment", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        sortable: true, unSortIcon: true, filter: 'agTextColumnFilter', cellClass: "left_align", minWidth: 200, autoHeight: true,
        cellRenderer: GridTextEditorComponent,
        cellRendererParams: { column: 'evaluation_commentCOL', placeholder: this.const_headr_evl, isWriteAccess: this.PCSWriteAccess },
      }, {
        headerName: this.const_header_vol, field: "volumeM3", minWidth: 80, width: 80,
        cellRenderer: GridTextEditorComponent, sortable: true, unSortIcon: true,
        cellRendererParams: { column: 'volumeM3COL', placeholder: "Volume M3", isWriteAccess: this.PCSWriteAccess },
      }, {
        headerName: "Miles Saved", field: "milesSaved", minWidth: 80, width: 80,
        cellRenderer: GridTextEditorComponent, sortable: true, unSortIcon: true,
        cellRendererParams: { column: 'milesSavedCOL', placeholder: "Miles Saved", isWriteAccess: this.PCSWriteAccess },
      }, {
        headerName: "LM", field: "lm", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', width: 150, minWidth: 150, sortable: true, unSortIcon: true,
        cellRenderer: GridDropdownEditorComponent,
        cellRendererParams: { column: 'lmCOL', isWrireAccess: this.PCSWriteAccess },
      }, {
        headerName: "Diagram", field: "diagram", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', width: 150, minWidth: 150, sortable: true, unSortIcon: true,
        cellRenderer: GridDropdownEditorComponent,
        cellRendererParams: { column: 'diagramCOL', isWrireAccess: this.PCSWriteAccess },
      }, {
        headerName: "Sketch", field: "sketch", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', width: 150, minWidth: 150, sortable: true, unSortIcon: true,
        cellRenderer: GridDropdownEditorComponent,
        cellRendererParams: { column: 'sketchCOL', isWrireAccess: this.PCSWriteAccess },
      }, {
        headerName: this.const_header, field: "dsReqNeeded", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', minWidth: 110, width: 110, sortable: true, unSortIcon: true,
        cellRenderer: GridDropdownEditorComponent,
        cellRendererParams: { column: 'dsReqNeededCOL', isWrireAccess: this.PCSWriteAccess },
      }, {
        headerName: "DS Without Request Suppliers", field: "dsWoReqSuppliers", floatingFilterComponentParams: { suppressFilterButton: true }, floatingFilter: true,
        filter: 'agTextColumnFilter', minWidth: 180, width: 180, sortable: true, unSortIcon: true,
        cellRenderer: GridDropdownEditorComponent,
        cellRendererParams: { column: 'dsWoReqSuppliersCOL', isWrireAccess: this.PCSWriteAccess },
      }, {
        headerName: "Comments (consolidated, reduce freq or deleted stops)", field: "comments", minWidth: 250, width: 250, cellClass: "left_align", autoHeight: true,
        cellRenderer: GridTextEditorComponent, sortable: true, unSortIcon: true,
        cellRendererParams: { column: 'commentsCOL', placeholder: "Comments", isWriteAccess: this.PCSWriteAccess },
      },
    ];

  }

  dateComparator(date1, date2) {
    const date1Number = monthToComparableNumber(date1);
    const date2Number = monthToComparableNumber(date2);
    if (date1Number == null && date2Number == null) {  // NOSONAR
      return 0;
    }
    if (date1Number == null) {  // NOSONAR
      return -1;
    }
    if (date2Number == null) {  // NOSONAR
      return 1;
    }
    return Number(date1Number) - Number(date2Number);
  }

  refreshData() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.updatedRowIds = []

    this.contingencyPCSService.loadDataContingencyPCS(this.selected_period_id).subscribe(
      response => {

        if (response.length > 0) {
          this.getColDefs();
          this.gridApi?.refreshHeader()
          this.displayRowData = response
          this.oldDataArray = JSON.parse(JSON.stringify(this.displayRowData));
          this.syncGridWithArrayData();
        } else {
          this.getColDefs();
          this.displayRowData = []
          this.gridApi?.refreshHeader()
          this.syncGridWithArrayData();
        }

        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
      }, _error => {

        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
      }
    );
  }
  syncGridWithArrayData() {
    const model = this.gridApi?.getFilterModel();
    this.gridApi?.setGridOption('rowData', this.displayRowData)
    this.rowCount = this.displayRowData.length;
    this.gridApi?.setFilterModel(model);

    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  }

  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL") {  // NOSONAR
      this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length));
    }
    else {
      this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
    }
  }
  goToNexpage() { this.gridApi.paginationGoToNextPage(); }

  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage() }

  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }

  goToLastPage() { this.gridApi.paginationGoToLastPage() }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  exportHistory() {
    if (this.displayRowData) {
      if (this.displayRowData.length > 0) {
        const exportData = [];
        this.displayRowData.forEach(e => {
          const obj = {
            period: this.selected_period_value,
            contprodDate: e.contprodDate,
            doubleshipDate: e.doubleshipDate,
            plant: e.plant,
            domicile: e.domicile,
            route: e.route,
            nasuppliercode: e.nasuppliercode,
            dock: e.dock,
            evaluation_comment: e.evaluation_comment,
            volumeM3: e.volumeM3,
            milesSaved: e.milesSaved,
            lm: e.lm,
            diagram: e.diagram,
            sketch: e.sketch,
            dsReqNeeded: e.dsReqNeeded,
            dsWoReqSuppliers: e.dsWoReqSuppliers,
            comments: e.comments
          };
          exportData.push(obj);
        });

        const headers = ['Period', this.const_headr_prdn, this.const_headr_date, 'Plant', 'Domicile', this.const_headr_route, this.const_headr_sppl, 'Dock', this.const_headr_evl, this.const_header_vol, 'Miles Save', 'LM', 'Diagram', 'Sketch', this.const_header, 'DS Without Request Suppliers', 'Comments (consolidated, reduce freq, or deleted stops)'];

        this.excelService.exportAsExcelFile(exportData, 'CONTINGENCY-PCS - ' + this.selected_period_value, headers);
      }
    }
  }
  exportHistoryOnlyDS() {
    if (this.displayRowData.length) {
      const exportData = [];
      this.displayRowData.forEach(e => {
        if (e.dsReqNeeded == "Y" || e.dsReqNeeded == "") {  // NOSONAR
          const obj = {
            period: this.selected_period_value,
            contprodDate: e.contprodDate,
            doubleshipDate: e.doubleshipDate,
            plant: e.plant,
            domicile: e.domicile,
            route: e.route,
            nasuppliercode: e.nasuppliercode,
            dock: e.dock,
            evaluation_comment: e.evaluation_comment,
            volumeM3: e.volumeM3,
            milesSaved: e.milesSaved,
            lm: e.lm,
            diagram: e.diagram,
            sketch: e.sketch,
            dsReqNeeded: e.dsReqNeeded == "Y" ? "Yes" : "Evaluation not determined",  // NOSONAR
            comments: e.comments,
            namc: ''
          };
          exportData.push(obj);
        }
      });

      const headers = ['Period', this.const_headr_prdn, this.const_headr_date, 'Plant', 'Domicile', this.const_headr_route, this.const_headr_sppl, 'Dock', this.const_headr_evl, this.const_header_vol, 'Miles Save', 'LM', 'Diagram', 'Sketch', this.const_header, 'Comments (consolidated, reduce freq, or deleted stops)', 'NAMC Approval'];
      this.excelService.exportAsExcelFile(exportData, 'CONTINGENCY-PCS - CONT DS REQ - ' + this.selected_period_value, headers);
    }
  }

  AddContignency() {
    if (this.selected_period_id) {
      const dialogRef = this.dialog.open(AddContingencyDialogComponent, {
        disableClose: true,
        width: '1000px',
        height: '480px',
        data: {
          header: 'Add Contingency',
          eventType: 'ADD',
          periodID: this.selected_period_id,
          domicileRouteMasterList: this.domicileRouteMasterList,
          plantList: this.plantList,
          dockList: this.dockList,
          contDoubleMasterList: this.contDoubleMasterList,
          dsReqNeedList: this.dsReqNeedList,
          dsWithoutReqSuppliers: this.dsWithoutReqSuppliers,
          plantDockList: this.plantDockList,
          lmDiagramSketch: this.lmDiagramSketch,
        }
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result.event == 'SaveEvent') {  // NOSONAR
          if (result.eventResult == "Success") {  // NOSONAR
            this.successMessage = this.constants.APIDataSaved;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
            this.refreshData();
          }
        }
      });
    } else {
      this.errorMessage = "Please select Period";
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
    }
  }

  AddToQueue(): void {

    const dialogRef = this.dialog.open(AddQueueDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: { header: 'Add To Queue' }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      if (result.event == 'SaveEvent') {  // NOSONAR
        if (result.data == "Success") {  // NOSONAR
          this.successMessage = this.constants.APIAddToQueueSuccess;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }
    });
  }
  openRouteLevel(route) {
    this.router.navigate([`${route}`]);
  }

  saveContingencyPCS() {
    const updatedRowsToSave = []
    this.updatedRowIds = [... new Set(this.updatedRowIds)]
    if (this.updatedRowIds.length == 0) {  // NOSONAR
      this.errorMessage = this.constants.noNewDataToUpdate;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
      return;
    }

    this.updatedRowIds.forEach(x => {
      const tempUpdatedPCSRow = this.displayRowData.find(y => y.contingencypcsID == x)   // NOSONAR
      if (tempUpdatedPCSRow) {
        if (this.isValueOk(this.selected_period_id)) {

          this.errorMessage = "Select Period";
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime)
          return;
        } else if ((tempUpdatedPCSRow.dsReqNeeded == 'Y') && (tempUpdatedPCSRow.lm == "INCOMPLETE" || tempUpdatedPCSRow.diagram == "INCOMPLETE" || tempUpdatedPCSRow.sketch == "INCOMPLETE")) {  // NOSONAR
          this.errorMessage = "Please complete LM, Diagram and Sketch Evaluation for DS Request to be Yes.";
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime)
          return;
        }
        else {
          const formattedObjPCS = {
            contingencypcsID: Number(tempUpdatedPCSRow.contingencypcsID),
            contprodDate: tempUpdatedPCSRow.contprodDate,
            doubleshipDate: tempUpdatedPCSRow.doubleshipDate,
            plant: tempUpdatedPCSRow.plant,
            domicile: tempUpdatedPCSRow.domicile,
            route: tempUpdatedPCSRow.route,
            nasuppliercode: tempUpdatedPCSRow.nasuppliercode,
            dock: tempUpdatedPCSRow.dock,
            evaluation_comment: tempUpdatedPCSRow.evaluation_comment,
            volumeM3: Number(tempUpdatedPCSRow.volumeM3),
            milesSaved: Number(tempUpdatedPCSRow.milesSaved),
            lm: tempUpdatedPCSRow.lm,
            diagram: tempUpdatedPCSRow.diagram,
            sketch: tempUpdatedPCSRow.sketch,
            dsReqNeeded: tempUpdatedPCSRow.dsReqNeeded,
            dsWoReqSuppliers: tempUpdatedPCSRow.dsWoReqSuppliers,
            comments: tempUpdatedPCSRow.comments
          }
          updatedRowsToSave.push(formattedObjPCS)
        }
      }


    });
    if (updatedRowsToSave.length == this.updatedRowIds.length) {  // NOSONAR
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.contingencyPCSService.updateContingencyPCS(updatedRowsToSave).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response == "Success") {  // NOSONAR
            this.successMessage = this.constants.APIDataSaved;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
            this.refreshData();
          } else {
            this.errorMessage = this.constants.APIErrorMessage;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
            return;
          }
        }, _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
          return;
        }
      )
    }
  }

  isValueOk(param: any): boolean {
    if (param == undefined || param == null || param == "") {  // NOSONAR
      return true;
    }
    return false;
  }

  displayDeleteDialog() {
    this.updatedRowIds = [... new Set(this.updatedRowIds)]

    const dialogRef = this.dialog.open(
      DeleteDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '170px',
      data: {
        header: 'Are you sure you want to delete selected PCS Records?',
        description: this.updatedRowIds.length + " Records selected ",
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (this.updatedRowIds.length <= 10) {
        if (result.event == 'ConfirmEvent') {  // NOSONAR
          this.DeleteContignency();
        } else {
          return;
        }
      } else {
        alert("Please select ten or less records for deletion");
        return;
      }
    });
  }

  DeleteContignency() {

    const updatedRowsToDelete = []
    this.updatedRowIds.forEach(x => {
      if (!this.isValueOk(x)) {
        const formattedObjPCS = { contingencypcsID: Number(x) }
        updatedRowsToDelete.push(formattedObjPCS)
      }
    });
    if (updatedRowsToDelete.length == this.updatedRowIds.length) {  // NOSONAR
      this.ngxUiLoaderService.start(this.constants.LoaderComponent)
      this.contingencyPCSService.deleteContingencyPCS(updatedRowsToDelete).subscribe(
        response => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          if (response == "Success") {  // NOSONAR
            this.successMessage = this.constants.APIDataDeleted;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
            this.refreshData()
          } else {
            this.errorMessage = this.constants.APIErrorMessage;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
          }
        }, _error => {
          this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          this.errorMessage = this.constants.APIErrorMessage;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      )
    } else {
      this.errorMessage = this.constants.APIErrorMessage;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
    }
  }
}
function monthToComparableNumber(date) {
  if (date == undefined || date == null || date.length != 10) {  // NOSONAR
    return null;
  }
  const yearNumber = Number.parseInt(date.substring(6, 10));
  const dayNumber = Number.parseInt(date.substring(3, 5));
  const monthNumber = Number.parseInt(date.substring(0, 2));
  return yearNumber * 10000 + monthNumber * 100 + dayNumber;  
}
